import './provider-cards.scss';
import './provider-cards.html.twig';

export default function () {
  const wrappers = document.querySelectorAll('.course-cards-container__cards');
  wrappers.forEach(wrapper => {
    const showMore = wrapper.querySelector('.provider-cards__show-more a');
    if (showMore) {
      showMore.addEventListener('click', (e) => {
        e.preventDefault();
        const hiddenItems = wrapper.querySelectorAll('.provider-cards__card-wrapper--hidden');
        if (hiddenItems.length <= 3) {
          showMore.remove();
        }
        for (const [index, item] of hiddenItems.entries()) {
          if (index < 3) {
            item.classList.remove('provider-cards__card-wrapper--hidden');
          }
          else {
            return;
          }
        }
      });
    }
  });
}